import { VotingDimension } from '@data/eve-sdk-web';

export const getVideoIdForVotingDimension = (
  dimension: VotingDimension,
): string | undefined =>
  dimension.refs.find((ref) => ref.type === 'videoId')?.id;
